import { DocumentTypeAttribute } from './documentTypeAttribute.model';
import { BaseDocument } from '../base/BaseDocument';
import { IBaseEnumEntity } from '../base/interfaces/IBaseEnumEntity';

export class DocumentType extends BaseDocument implements IBaseEnumEntity {
    id: string;
    name: string;
    systemCode: string;
    attributeLeft: string;
    attributeRight: string;
    isCommon: boolean;
    hasIndex: boolean;
    attributes: DocumentTypeAttribute[];
    /**
     *
     */
    constructor() {
      super();
      this.attributes = [];
    }
  }
